// extracted by mini-css-extract-plugin
export default {"contenedor":"styles_contenedor__mmNzm","marca":"styles_marca__aV91V"};